export const formatMoney = (amountCents: number | null): string | null => {
	return amountCents ? `$${(amountCents / 100).toFixed(2)}` : "";
};
